const { Queue, priorities } = require('@nx-js/queue-util')
const { scores, weights } = require('../config')
const _ = require('morphable')

module.exports = createCourses

function createCourses (initCourses = []) {
  const state = _({
    courses: [],
    newCourse (name = '', grade = '', credits = 0, weight = 'Regular (4.0)') {
      const id = (Math.random()).toString(36).slice(-5)
      const course = { id, name, grade, credits, weight, remove: () => {
        if (state.courses.length == 1) {
          state.newCourse()
        }
        rm(state.courses, id)
      }
      }
      state.courses.push(course)
      focusOnNewCourse()
    },
    get weightedPoints () {
      return state.courses.reduce((prev, next) => prev + next.credits * (scores[next.grade] + weights[next.weight] - 4), 0)
    },
    get unweightedPoints () {
      return state.courses.reduce((prev, next) => prev + next.credits * scores[next.grade], 0)
    },
    get credits () {
      return state.courses.reduce((prev, next) => prev + Number(next.credits), 0)
    },
    get gpa () {
      return state.weightedPoints / state.credits
    },
    get unweighted () {
      return state.unweightedPoints / state.credits
    }
  })

  initCourses.forEach(({ name, grade, credits, weight }) => state.newCourse(name, grade, credits, weight))

  if (initCourses.length == 0) state.newCourse()

  return state
}

function rm (arr, id) {
  arr.splice(arr.map(item => item.id).indexOf(id), 1)
}

function focusOnNewCourse () {
  setTimeout(function () {
    if (typeof window !== 'undefined') {
      var courses = document.getElementsByClassName('course-name')
      var input = courses[courses.length - 1].getElementsByTagName('input')[0]
      input.focus()
    }
  }, 1)
}
